import { useState } from 'react'
import Modal from 'antd/es/modal'
import Button from 'components/button'
import { reportStatuses, EmployeeReportStatus, ChangeMultipReportStatusVariables } from 'models'
import Select from 'antd/es/select'
import { useEffect } from 'react'

type Props = {
  visible: boolean
  onClose: () => void
  isAdmin: boolean
  onSave: (params: ChangeMultipReportStatusVariables) => void
  selectedReportIds: string[]
}

export const ChangeReportStatusModal = (props: Props) => {
  const [selectedStatus, setSelectedStatus] = useState<EmployeeReportStatus | undefined>(undefined)

  useEffect(() => {
    setSelectedStatus(undefined)
  }, [props.visible])

  return (
    <Modal
      visible={props.visible}
      onCancel={() => props.onClose()}
      title={<h1>Haluatko muuttaa raporttien tilaa?</h1>}
      closeIcon={false}
      closable={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label={'Sulje'}
            onClick={() => {
              props.onClose()
            }}
            color="default"
            style={{ marginRight: '1em' }}
          />
          <Button
            label={'Muuta'}
            onClick={() => {
              if (selectedStatus) {
                props.onSave({ status: selectedStatus, _ids: props.selectedReportIds })
              }
            }}
            color="blue"
            disabled={!selectedStatus}
          />
        </Button.ButtonGroup>
      }
    >
      <>
        <div style={{ marginBottom: '1em' }}>
          Olet valinnut {props.selectedReportIds.length} {props.selectedReportIds.length === 1 ? 'raportin' : 'raporttia'}. Valitse uusi tila.
        </div>
        <Select
          style={{ width: '200px', marginTop: '1em' }}
          value={selectedStatus}
          onChange={(value) => {
            setSelectedStatus(value)
          }}
        >
          {reportStatuses
            .filter((item) => {
              if (props.isAdmin) {
                return true
              } else {
                return item.key === 'waiting_for_approval'
              }
            })
            .map((item) => {
              return <Select.Option value={item.key}>{item.secondary_value}</Select.Option>
            })}
        </Select>
      </>
    </Modal>
  )
}
